var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('my-tabs'),_c('div',{staticClass:"card"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }